import { makeSimpleDigitalSensorElement } from "./simpleDigitalSensorElements.js";

export const valveStateElementConfig = makeSimpleDigitalSensorElement("code", 1);
